import companies from './companies';
import order from './order';
import orders from './orders';
import pois from './pois';
import service from './service';
import newuser from './newuser';

export default {
  companies,
  order,
  orders,
  pois,
  service,
  newuser,
};
